export default "__VITE_ASSET__i9uLywth__"